import React from "react";
// eslint-disable-next-line import/no-cycle
import { SvgProps } from ".";

export const Minus: React.FC<SvgProps> = ({ fill, width, height }) => (
  <svg
    aria-labelledby="minus"
    height={height || "15px"}
    version="1.1"
    viewBox="0 0 12 12"
    width={width || "15px"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="minus">Minus</title>
    <g id=".org" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Accordians" transform="translate(-498.000000, -2257.000000)">
        <g
          id="Full-width-Accordian"
          transform="translate(130.000000, 2183.000000)"
        >
          <g
            id="2.-Text-links/z_Parts/SM-Yellow"
            transform="translate(362.000000, 68.000000)"
          >
            <g id="Group" transform="translate(6.000000, 6.000000)">
              <rect id="Rectangle" x="0" y="0" width="12" height="12" />
              <line
                x1="1.875"
                y1="6.0265625"
                x2="10.125"
                y2="6.0265625"
                id="Path"
                stroke={fill || "#252525"}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default {};
